export const integrations = {
  providers: [
    { key: 'google', name: 'Google Ads', connected: true },
    { key: 'meta',   name: 'Meta Ads',   connected: true },
    { key: 'tiktok', name: 'TikTok Ads', connected: true },
    { key: 'ga4',    name: 'Google Analytics 4', connected: false },
  ],
};
